<template>
  <div class="methodology">
    <div class="splash-header">
      <div class="header-copy app-center">
        <div class="inner-header-copy">
          <p
            class="knuvu-title"
          >KnuVu is a Quantitative Qualitative Multivariate Heatmapping Decision Tool.</p>
          <p class="knuvu-subtitle">A wha-wha-wha? I know, we get it.</p>
          <p
            class="tagline"
          >The easiest way to describe the KnuVu Tool is as a Visual Porter Model when appliedto Competitive Strategy and Corporate Development.</p>
        </div>
      </div>
    </div>
    <TextPage>
      <div class="screenshot-section">
        <img alt="Knuvu Screen" src="../assets/screenshots/knuvu-screen-2.png" class="screenshot" />
        <p class="screenshot-title">Ready to see what this actually looks like?</p>
        <p class="screenshot-subtitle">Here's a sample KnuVu output.</p>
      </div>
      <div class="how-to-create">
        <p>
          KnuVu was built on
          <a
            href="https://ricmerrifield.com/about-ric/"
            target="_blank"
          >Ric Merrifield</a>’s
          <a
            href="https://www.amazon.com/Rethink-Business-Manifesto-Innovation-paperback/dp/0133829146"
            target="_blank"
          >ReThink</a> framework that has been deployed for Balanced Score Card and Business Capability Mapping. Many companies use conditional formatting in Excel to add an additional visual valuation to an x,y coordinate. By incorporating a relational database over Excel flat-file KnuVu allows that coordinate to include other valuation attributes including quantitative measurements such as cost, risk or certainty, time sensitivity, or qualitative values for level of importance, alignment to corporate values or KPIs, or surveying.
        </p>
        <p class="knuvu-subtitle">What’s a KnuVu?</p>
        <p class="no-top-padding">
          By lining up candidates on the Y-axis and Points of Analysis (PoA) in the X-axis, and grouping those PoA’s logically, KnuVu is able to provide incredible insight to enterprises. As a default, we heatmap according to performance and prioritization. However, we also allow labels to be layered above the heatmap to get descriptive.
          Finally, and this is where it gets multivariate, we allow multiple inputs per Discrete Point of Analysis (An X,Y intersection point, or “dPoA”) so that any PoA may be evaluated on attributes such as time, materials, tasks, resources, etc.—all of which would sum up to Cost and then, in addition, we are able to evaluate based on additional axis’ such as risk, or confidence.
        </p>
        <p>KnuVu’s are created by importing structured datasets or manually, using a dynamic surveying front-end. We have a simple API which allows KnuVu to import or sit on top of your readily accessible or available Data.</p>
      </div>
    </TextPage>
  </div>
</template>

<script>
import TextPage from "@/components/global/text-page.vue";
export default {
  name: "Methodology",
  title: "Methodology - Knuvu",
  components: {
    TextPage,
  },
};
</script>

<style scoped lang="scss">
div.methodology {
  div.splash-header {
    padding: 16px 0 45px 0;
    min-height: 200px;
    background: #ffffff; /* Old browsers */
    background: -moz-linear-gradient(
      top,
      #ffffff 0%,
      #ffffff 50%,
      #d6e8f2 100%
    ); /* FF3.6+ */
    background: -webkit-gradient(
      linear,
      left top,
      left bottom,
      color-stop(0%, #ffffff),
      color-stop(50%, #ffffff),
      color-stop(100%, #d6e8f2)
    ); /* Chrome,Safari4+ */
    background: -webkit-linear-gradient(
      top,
      #ffffff 0%,
      #ffffff 50%,
      #d6e8f2 100%
    ); /* Chrome10+,Safari5.1+ */

    div.header-copy {
      div.inner-header-copy {
        p.knuvu-title {
          max-width: 650px;
          padding-bottom: 18px;
        }
        p.knuvu-subtitle {
          padding-bottom: 8px;
        }
        p.tagline {
          max-width: 545px;
        }
      }
    }
  }

  div.screenshot-section {
    position: relative;
    float: right;
    top: -138px;
    width: 400px;

    img.screenshot {
      width: 400px;
    }

    p {
      text-align: center;

      &.screenshot-title {
        font-weight: 600;
        color: #49a9dc;
        padding-top: 8px;
      }
      &.screenshot-subtitle {
        font-size: 14px;
      }
    }
  }

  div.how-to-create {
    padding-top: 30px;
    max-width: 670px;

    p {
      &.no-top-padding {
        padding-top: 0;
      }
    }
  }
}
</style>